import moment from "moment";

import { DateSelector } from "@/Common/Components/Inputs/DateSelector";
import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { IPatientEnrollmentModel } from "@/Common/Models/Patient/UI/Profile/IPatientEnrollmentModel";
import { RAMQInscription } from "@/Common/Models/RAMQ/RAMQInscription";
import { SitesModel } from "@/Common/Models/Sites/SitesModel";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { IPatientProfileEnrollmentComponentProps } from "./IPatientProfileComponentProps";

class PatientProfileEnrollmentLieuSuiviComponent extends React.Component<IPatientProfileEnrollmentComponentProps, any> {
    public render(): JSX.Element {
        var enrolmentModel = this.props.model;
        var ramqInfo: RAMQInscription;

        if (enrolmentModel) {
            ramqInfo = enrolmentModel.get("RAMQInscription");
        }

        return this.GetLieuRender(ramqInfo, enrolmentModel, this.props.IsInAddMode || this.props.IsInEditMode);
    }

    private GetLieuRender(ramqInfo: RAMQInscription, model: IPatientEnrollmentModel, showAddEdit: boolean): JSX.Element {
        var lieuRender: JSX.Element = null;
        var lieux: JSX.Element[] = null;

        var availableLieux: SitesModel[] = [];
        if (model && model.get("AvailableLieuSuivi"))
            availableLieux = model.get("AvailableLieuSuivi").toArray();

        if (showAddEdit) {
            lieuRender = (
                <tbody key="lieusuivi">
                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("FollowupLocationLabel")}</span>
                        </td>
                        <td className="c2">
                            <select onChange={this.onLieuSuiviChange.bind(this)} className="form-control myle-control" value={model.get("SelectedLieuSuiviId") ? model.get("SelectedLieuSuiviId") : ""}>
                                <option value=""> </option>
                                {availableLieux.map((p: SitesModel, idx) => (
                                    <option key={"site" + idx} value={p.Model.Id}> {p.Model.ClinicalName}</option>
                                ))}
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td className="c1pad form">
                            <span>{cacheStore.GetString("StartDateLabel")}</span>
                        </td>
                        <td className="c2">
                            <DateSelector id="datelieusuivi" cssClass="auto-width" dateFormat="dddd, MMM dd, yyyy" disabled={false} date={model.get("DateDebutLieuSuivi")} onSelectOp={LocalPatientOperations.Profile.Enrollment_LieuSuiviDateChange} />
                        </td>
                    </tr>
                </tbody>
            );
        }
        else if (ramqInfo) {
            if (ramqInfo.Lieux && ramqInfo.Lieux.length > 0) {
                var x = ramqInfo.Lieux[0];

                return (
                    <tbody key="lieusuivi">
                        <tr>
                            <td className="c1pad form">
                                <span>{cacheStore.GetString("FollowupLocationLabel")}</span>
                            </td>
                            <td className="c2">
                                <strong>{MyleHelper.ReplaceEmptyString(x.CodeLieu ? x.CodeLieu.toString() : "")}</strong>
                            </td>
                        </tr>

                        <tr>
                            <td className="c1pad form">
                                <span>{cacheStore.GetString("StartDateLabel")}</span>
                            </td>
                            <td className="c2">
                                <strong>{MyleHelper.ReplaceEmptyString(moment(x.Date).format("YYYY-MM-DD"))}</strong>
                            </td>
                        </tr>
                    </tbody>
                );
            }

            lieuRender = <div>  {lieux} </div>;
        }
        else {
            lieuRender = (<div />);
        }

        return lieuRender;
    }

    private onLieuSuiviChange(e: React.ChangeEvent<HTMLSelectElement>): void {
        var operation = new LocalEvent(LocalPatientOperations.Profile.Enrollment_LieuSuiviChange);
        operation.AddItem("value", e.target.value);
        LocalEventDispatcher.dispatch(operation);
        e.preventDefault();
    }
}

export { PatientProfileEnrollmentLieuSuiviComponent };
